import ABaseComponent from '../../../ABaseComponent';
import Style from './card.css'
import classnames from 'classnames';

export default class Card extends ABaseComponent {
    constructor(props) {
        super(props)
        this.state={
            ...props,
            data:props.data?props.data:[]
        }
        
    }
    componentDidMount(){
        super.componentDidMount()
    }

    setData =(data)=>{
        this.setState({data:data})
    }
    createContent() {

        const id = this.props.id;

        return (<div {...this.state} className={classnames(this.props.className,Style.monitorCard)}>
                    {this.state.data.map(item=>{
                        return <div className={Style.monitorItem}>
                            <div className={Style.monitorItemTitle}>{item.title}</div>
                            <div className={Style.monitorItemContent}>{item.content}</div>
                        </div>
                    })}
                </div>)
    }
}